export default function TextInput(props:React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> ) {
    return <input type="text" className="px-2 py-1 rounded-sm" {...props} />
}